import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../api/client';
import { Loading } from '../components/ProtectedRoute';
import { apiError } from '../lib/host';
import AuthShell from '../components/AuthShell';
import './Auth.css';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const setup = params.get('setup') === '1'; // the registration email's link: the first password
  const [check, setCheck] = useState({ state: 'loading' });
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setCheck({ state: 'invalid', message: 'This reset link is incomplete. Request a new one.' });
      return;
    }
    authAPI.checkResetToken(token)
      .then((res) => setCheck({ state: 'ok', hint: res.data.email_hint }))
      .catch((err) => setCheck({ state: 'invalid', message: apiError(err, 'This reset link is invalid or has expired.') }));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    if (form.password !== form.confirm) return setError("Passwords don't match");
    setLoading(true);
    setError('');
    try {
      const res = await authAPI.resetPassword(token, form.password);
      navigate('/login', { replace: true, state: { success: res.data.message } });
    } catch (err) {
      setError(apiError(err, 'Could not reset the password'));
      setLoading(false);
    }
  };

  if (check.state === 'loading') return <Loading />;

  const set = (e) => { setForm({ ...form, [e.target.name]: e.target.value }); setError(''); };
  return (
    <AuthShell>
      <h2>{setup ? 'Create your password' : 'Set a new password'}</h2>
      {check.state === 'invalid' ? (
        <>
          <div className="error-message">{check.message}</div>
          <Link to="/forgot-password" className="submit-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            Request a new link
          </Link>
        </>
      ) : (
        <>
          <p className="tcx-hint" style={{ marginBottom: 16 }}>For {check.hint}</p>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="password">New password</label>
              <input id="password" name="password" type="password" minLength={6} required disabled={loading}
                autoComplete="new-password" value={form.password} onChange={set} />
              <small className="tcx-hint">At least 6 characters.{setup ? '' : " You'll be signed out on all other devices."}</small>
            </div>
            <div className="form-group">
              <label htmlFor="confirm">Confirm new password</label>
              <input id="confirm" name="confirm" type="password" required disabled={loading}
                autoComplete="new-password" value={form.confirm} onChange={set} />
            </div>
            <button className="submit-btn" disabled={loading}>{loading ? 'Saving...' : setup ? 'Create password' : 'Reset password'}</button>
          </form>
        </>
      )}
      <p className="auth-link"><Link to="/login">Back to login</Link></p>
    </AuthShell>
  );
}
